import React, { Component } from 'react';
import './Insericredito.css';
// import { Bank } from '../../libs/bank'
import { Config } from "../../Config";
//import iddp from '../../images/public/registeration/iddp.png';
import clos from '../../images/public/registeration/clos.png';
//import cdc1 from '../../images/public/registeration/cdc1.png';
//import cdc2 from '../../images/public/registeration/cdc2.png';
//import cdc3 from '../../images/public/registeration/cdc3.png';
//import cdd1 from '../../images/public/registeration/cdd1.png';
//import cdd2 from '../../images/public/registeration/cdd2.png';
//import cdd3 from '../../images/public/registeration/cdd3.png';
//import { element } from 'prop-types';
//import classNames from 'classnames';
//import { BrowserView, MobileView, TabletView, isBrowser, isMobile, isTablet, isMobileOnly, isAndroid, isIOS, isFirefox, browserName } from 'react-device-detect';
import { BrowserView, MobileView } from 'react-device-detect';
//import { Rectangle, Circle, Ellipse, Line, Polyline, CornerBox, Triangle } from 'react-shapes';
//import { RadioGroup, Radio } from 'react-radio-group';
//import { height } from 'window-size';
//import WebFont from 'webfontloader';
//import { BrowserRouter as Router, Route, Link, Redirect } from "react-router-dom";
import { BrowserRouter as Router } from "react-router-dom";
//import Acquistuato from '../Acquistuato/Acquistuato';
import tr from '../../libs/tr'
import AlertPnl from "../../assets/components/panel/AlertPnl";
//import { YearPicker, MonthPicker, DayPicker } from 'react-dropdown-date';
import { YearPicker, MonthPicker } from 'react-dropdown-date';
import WaitLoad from "../../assets/components/loading/WaitLoad";
// import {} from '../../libs/fetch'
import Cleave from 'cleave.js/react';
import Cookies from 'universal-cookie';
// import Iframe from 'react-iframe'
import visacard from '../../images/public/bank/Visa.png'
import mastercard from '../../images/public/bank/Mastercard.png'
import masterviza from '../../images/public/bank/masterviza.png'
import qmark from '../../images/public/bank/qmark.png'
import creditCardType from 'credit-card-type';
//import List from '../../assets/components/list';
//import { Button, Container, Row, Col, Modal } from 'react-bootstrap';
//import { HtmlWrapper, fontStyles, getRouteName } from '../../Utils';
import { HtmlWrapper } from '../../Utils';
// import { getWorkFlow, modifyWorkflow, workflowState, updateWorkflow, workflowTransition, workflowHelp } from "../../libs/workflow";
import MPWorkFlow from "../../libs/workflow";
import { userFetch, userLogoutFetch } from '../../libs/fetch';
import InfoModal from "../../assets/components/Modal/Modal";
import GestPayHandler from '../../assets/components/bank/GestPayHandler';
//import itabar3 from '../../images/public/registeration/nav3i.png';
//import engbar3 from '../../images/public/registeration/nav3e.png';
//import simplebar3 from '../../images/public/registeration/mobilenav3.png';
import TopBar from '../../assets/components/topbar/TopBar';
import ProgressBullets from '../../assets/components/progressBullets/ProgressBullets';
import logo from '../../images/public/login/logo.png';
//import miniArrow from '../../images/public/registeration/miniarrow.png';

const cookies = new Cookies();
class Insericredito extends Component {
	constructor(props) {
		super(props);

		//let params = null;
		//console.log('[Insericredito]', params);

		this.state = {
			step: '3',
			modal: false,
			alertWrong: false,
			loadedData: false,
			isLoading: false,
			errmsg: null,
			errorFlg: false,
			purchaseCart: null, //the data inside strPurchaseCard is parsed and converted to object array as we want and then is stored in storage
			user: null,
			totalPrice: 0,
			//TODO: check if needed to maintain these info or I should use bank page
			cardHolder: "",
			cardNumber: "",
			cvv: "",
			expDate: "",
			yyyy: "",
			mm: "",
			paymentType: "insertAndPay",//change this if you don't need it
			tokenized: true,
			ccType: '', //Visa, Mastercard, etc.
			ccInfoErr: true,
			errCvv: false,
			errCardHolderName: false,
			errCCNumber: false,
			//3dsecure
			iframeVisible: "hidden",
			price_1_description: "N° 2 card",
			price_2_description: "Spedizione",
			price_1: 0,
			price_2: 0,
			price_info: [],
			bankErrMsg: tr.t("Nosuccess"),
		};
		
		this.onCreditCardChange = this.onCreditCardChange.bind(this);
		this.onCVVchange = this.onCVVchange.bind(this);
		this.CCStartYear = new Date().getFullYear();
		this.CCEndYear = this.CCStartYear + 10;
	}

	onCreditCardChange(event) {
		//console.log('card event.target.rawValue:', event.target.rawValue);
		this.setState({ cardNumber: event.target.rawValue, errCCNumber: false });
		let cardType = creditCardType(event.target.rawValue);
		//console.log('cardType: ', cardType);
		this.setState({ ccType: event.target.rawValue.length > 0 && cardType && cardType[0] ? cardType[0].niceType : '' });
	}

	onCVVchange(event) {
		// // formatted pretty value
		// console.log(event.target.value);
		// raw value
		//console.log(event.target.rawValue);
		this.setState({ cvv: event.target.rawValue ,errCvv: false });
	}

	onqmarkClicked = () => {
		return  this.setState({ modal: true, alertWrong: false, cvvGuidAlert: true}) 
	}

	// componentWillUnmount() {
	//     window.removeEventListener('message', this.handleIframeTask);
	// }
	componentDidMount() {
		// this.wf = new MPWorkFlow();
		let access_token = cookies.get('access_token');
		this.checkForBankCallbackInURI();
		userFetch(this, { access_token: access_token }
      ).then((response) => {
			//console.log(response);
			if (response) {
        this.setState({ user: response });
					localStorage.setItem('user', JSON.stringify(response));
			}
			else {
        this.logout()
			}
		});
		// window.addEventListener('message', this.handleIframeTask);
		// let user = JSON.parse(localStorage.getItem('user'));
		let purchaseCart = JSON.parse(localStorage.getItem("purchaseCart"));
		// let totalPrice = JSON.parse(localStorage.getItem("totalPrice"));
		let price_info = JSON.parse(localStorage.getItem("price_info"));
		let totalPrice = price_info.priceToPay;
		this.setState({ purchaseCart, totalPrice, price_info },()=>{this.orderUserTotals();});
		// console.log('[Insericredito] @user: ', user);
		//console.log('[Insericredito] @purchaseCart: ', purchaseCart);
		//console.log('[Insericredito] @totalPrice: ', totalPrice);
		//console.log('[Insericredito] @price_info: ', price_info);
		// gettin Pay state data
		this.refresh();
	}

	// LOGOUT!
	logout = () => {
		try {
			// fill storage w/ user data.
			userLogoutFetch(this).then((response) => {
				//console.log(response);
				localStorage.clear();
				cookies.remove('access_token');
				return this.props.history.push('/');
			});
		}
		catch (e) {
			//console.log(e);
		}
	}
	// handleIframeTask = (e) => {
	//     //TODO: set this condition:
	//     // if (e.origin !== 'https://localhost:3000/') {
	//     //     return;
	//     // }
	//     console.log("iframe: @e", e);
	//     if (e.data) {
	//         if (e.data.charAt(0) == "%") {
	//             console.log(e.data);
	//             let params = JSON.parse(decodeURIComponent(e.data));
	//             console.log("iframe: @params", e);
	//             this.ifr.contentWindow.postMessage(JSON.stringify({ status: "responseHandler", params, TS: Date.now() }), '*');
	//         } else {
	//             let data = JSON.parse(e.data);
	//             console.log("iframe: @data", data);
	//             if (data.status) {
	//                 if (data.status.indexOf('_OK') !== -1) {
	//                     this.setState({ isLoading: false, iframeVisible: "hidden" });
	//                     //payment successful
	//                     console.log("BANK TRANSACTION: OK!", data.status, data.data);
	//                     //goto Acquistuato
	//                     // return this.props.history.push('/Acquistuato');
	//                     // TODO: decide what should be done after insertion of credit card during purchase
	//                     let screenData = this.state.screenData;
	//                     screenData.success = 1;
	//                     this.update();
	//                 }
	//                 if (data.status.indexOf('_ERROR') !== -1) {
	//                     this.setState({ isLoading: false });
	//                     //ERROR in payment
	//                     console.log("BANK TRANSACTION: ERROR!", data.status, data.data);
	//                     console.log("BANK TRANSACTION: ERROR!0000", data.status === 'SELLA_PROCESSING_ERROR',Number(data.data), Number(data.data)===8006);
	//                     if (data.status === 'SELLA_PROCESSING_ERROR' && Number(data.data)===8006) {
	//                         //3DSecure is requesting here
	//                         try {    
	//                             this.setState({iframeVisible: "visible"})            
	//                         } catch (error) {
	//                             console.warn("3DSecure", error);                   
	//                         }
	//                     }else{
	//                         console.error(data);
	//                         this.setState({ iframeVisible: "hidden", bankErrMsg: data.data ? data.data : this.state.bankErrMsg, alertWrong: true });
	//                     }
	//                 }
	//             }
	//         }
	//     }
	// }

	checkForBankCallbackInURI() {
		//console.log("[userarea] @checkForBankCallbackInURI #window.location: ", window.location.href);
		function findGetParameter( name ) {
			let url= window.location.href;
			name = name.replace(/[\[]/,"\\\[").replace(/[\]]/,"\\\]");
			var regexS = "[\\?&]"+name+"=([^&#]*)";
			var regex = new RegExp( regexS );
			var results = regex.exec( url );
			return results === null ? null : results[1];
		}
				
		var bankResponse = findGetParameter("bankResponse");
			//console.log("[userarea] @checkForBankCallbackInURI #bankResponse: ", bankResponse);

		if (bankResponse) {
			// clear browser
			window.location.href = window.location.href.split("?")[0];
			//console.log("[userarea] @checkForBankCallbackInURI #window.location.href.split(?)[0]: ", window.location.href.split("?")[0]);
			//console.log("[userarea] @checkForBankCallbackInURI #decodeURIComponent(data): ");
			if (bankResponse.indexOf("_OK") > -1) {
				// bring back the CC insertion
				this.setState({ isLoading: false });
				this.refreshAfterBankTransaction();
			}
			if (bankResponse.indexOf('_KO') > -1) {
				this.setState({ isLoading: false });
				//ERROR in payment
				// nothing to do
			}
		}
	}

	makeThePayment = (e) => {
		e.preventDefault();
		//console.log("[Insericredito] @makeThePayment");
		return this.onSubmitBankRequest();
	}

	onValueChanged = (e) => {
		// e.preventDefault();
		this.setState({
			checked: e.currentTarget.value
		});
		//console.log("[Insericredito] onValueChanged:  ", e.currentTarget.value);
	}

	handleChangeHolderName = (e) => {
		e.preventDefault();
		this.setState({
			cardHolder: e.currentTarget.value
		});
		//console.log("[Insericredito] handleChangeHolderName:  ", e.currentTarget.value);
	}

	alertResponse(info) {
		switch (info.type) {
			case "closeButton":
				this.setState({ modal: false, alertWrong: false, cvvGuidAlert: false})
				break;
			case "actionButton":
				if (info.option1 === "retry") {
					this.setState({ modal: false, alertWrong: false })
					break;
				}
				if (info.option2 === "gotouser") {
					this.setState({ modal: false, alertWrong: false })
					return this.props.history.push('/userarea');
				}
				if (info.option1 === "cvvOK") {
					this.setState({ modal: false, alertWrong: false , cvvGuidAlert: false })
					break;
				}                 
			}
		}

		// onSubmitBankRequest() {
		//     //TODO: set language and checked = true ,  if (e.origin !== 'https://localhost:3000/')
		//     this.setState({ isLoading: true });

		//     // let debugPrice = (this.state.totalPrice > 16) ? 16 : (this.state.totalPrice > 11) ? 11 : 9;

		//     let params = {
		//         bank: {
		//             shopLogin: Config.bank.shopLogin,
		//             portal: Config.bank.portal,
		//             test: Config.bank.test
		//         },
		//         userId: this.state.user.id_ut,
		//         paymentType: this.state.paymentType,
		//         amountCents: this.state.totalPrice * 100,
		//         // amountCents: debugPrice,
		//         checked: this.state.tokenized,
		//         configTest: Config.test,
		//         token: cookies.get('access_token'),
		//         EXPMM: this.state.mm.padStart(2, "0"),
		//         EXPYY: this.state.yyyy.substr(2, 2),
		//         CC: this.state.cardNumber,
		//         CVV2: this.state.cvv,
		//         BuyerName: this.state.cardHolder,
		//         lang: tr.userlng(),
		//     }
		//     console.log("[Insericredito] onSubmitBankRequest @params:  ", params);
		//     this.ifr.contentWindow.postMessage(JSON.stringify({ status: "loadInfo", params }), '*');
		// }

		onSubmitBankRequest() {
			this.setState({ isLoading: true});
			let params = {
				bank: {
					shopLogin: Config.bank.shopLogin,
					portal: Config.bank.portal,
					test: Config.bank.test
				},
				userId: this.state.user.id_ut,
				paymentType: this.state.paymentType,
				amountCents: Math.round(this.state.totalPrice * 100), //In case of edit or insertion, will be handled by bank
				checked: this.state.tokenized,
				configTest: Config.test,
				token: cookies.get('access_token'),
				EXPMM: this.state.mm.padStart(2, "0"),
				EXPYY: this.state.yyyy.substr(2, 2),
				CC: this.state.cardNumber,
				CVV2: this.state.cvv,
				BuyerName: this.state.cardHolder,
				lang: tr.userlng(),
				}
				//console.log("[Userarea] onSubmitBankRequest @params:  ", params);
				this.setState({gestpay: true, gestpayParams: params});
		}

		//validating credit card info in user level
		validateCCInfo = (e) => {
			e.persist()
			const { id, value, rawValue } = e.target
			//console.log(id, value, rawValue);
			switch (id) {
				case "ccNumber":
					//console.log("[Userarea] states :" + rawValue.length);
					this.setState({ errCCNumber: !(rawValue.length === 16) }, () =>
						this.checkCCInfo());
					break;
				case "cardHolder":
					this.setState({ errCardHolderName: !(value.trim().length > 0) }, () =>
						this.checkCCInfo());
					break;
				case "cvv":
					this.setState({ errCvv: !(parseInt(rawValue) > 0) }, () =>
						this.checkCCInfo());
					break;
				default:
					break;
			}
		}

		//disable/enable the "save" button!
		checkCCInfo = () => {
				return this.setState({ ccInfoErr: (this.state.errCCNumber || this.state.errCardHolderName || this.state.errCvv) });
		}




		// orders user's options by 'order' key inside 'options' object of screenData
		orderUserTotals() {
				// NOTE: each time an option changes, this function must be called after modifyWorkflow() call
				// order the options
				let totals = Object.values(this.state.price_info.info).sort((x, y) => x.order - y.order);
				// console.log("[Cart] @orderUserOptions #options:", options);
				this.setState({ userTotals: totals, userTotalsLastIndex: totals.length - 1 });;
		}


		async refresh() {
				// update screenData for current states
				await  MPWorkFlow.getInstance().getWorkFlow(this, MPWorkFlow.getInstance().getStageName("Pay"));
			
		}
		async update() {
				// updating server state...
				let resp = await MPWorkFlow.getInstance().workflowState(this, { state_data: this.state.screenData });
				console.log('[PurchaseCompleted] @update #resp', resp);
				if (!resp) return;
				if (resp.status === "success") {
						// updating localStorage
						MPWorkFlow.getInstance().updateWorkflow(this,resp.data);
						// back to the PurchaseCompleted
						return this.props.history.push('/transaction-confirm');

				} /* else if (resp.status === "fail") {
						this.setState({ canProceed: false, errorFlg: true, errmsg: resp.message });
				} */
		}

		async refreshAfterBankTransaction() {
				// update screenData for current states
				await MPWorkFlow.getInstance().getWorkFlow(this, MPWorkFlow.getInstance().getStageName("Pay"));
				let screenData = this.state.screenData;
				screenData.success = 1;
				this.update();
		}


		render() {
				//console.log('[Insericredito]', this.state);
				var formatter = new Intl.NumberFormat('en-US', {
						style: 'currency',
						currency: 'EUR',
						minimumFractionDigits: 2,
				});
				return (
					<Router>
						<div >
							<div>
								<BrowserView>
									<div className="container-fluid d-lg-none sn_mobile_top_row mt-5">
										<div className="row flex-nowrap">
											<div className="col-2 d-flex align-items-center">
											{/*	
												<button className="sn_btnbox" onClick={ this.onBack }><img className="sn_mobile_top_row_arrow" src={ miniArrow }/></button>
											*/}
											</div>
											<div className="col-8 d-flex align-items-center justify-content-center">
												<img className="sn_mobile_top_row_logo" src={ logo } />
											</div>
											<div className="col-2 d-flex align-items-center justify-content-end">
												<div className="sn_exit">
													<a onClick={() => { return this.props.history.push('/') }}>
														<img src={ clos } />
													</a>
												</div>
											</div>
										</div>
									</div>
									<div className="sn_topbar"><TopBar step={ this.state.step }/></div>
									<div className="sn_overlay d-lg-none"></div>
									<div className="sn_credit">
										<div className="container">
											<div className="row">
												<div className="col-12 col-lg-8 mx-auto">
													<div className="sn_register__container p-3 p-md-4 p-lg-5">
														<div className="row d-none d-lg-flex">
															<div className="col-12 d-flex justify-content-end">
																<div className="sn_exit">
																	<a onClick={() => { return this.props.history.push('/') }}>
																		<img src={ clos } />
																	</a>
																</div>
															</div>
														</div>
														<div className="row">
															<div className="col-12">
																<h3 className="text-center mb-4">{ tr.t("Insertpayinfo") }</h3> 
																<div className="sn_credit__container__rectangle">
																	{ 
																		this.state.cardNumber &&
																		<label htmlFor="ccNumber" className="top-label">
																			{ tr.t("Cardnum") }
																		</label>
																	}
																	<div className="sn_credit__container__wrap">
																		<div className="sn_credit__container__retangle__wrap__cards">
																			<img src= {this.state.ccType === 'Visa' ? visacard : this.state.ccType === 'Mastercard' ? mastercard : masterviza} />
																		</div>
																		<Cleave
																			id="ccNumber"
																			style={ {borderColor: this.state.errCCNumber ? 'red': ''} }
																			className="sn_credit__container__wrap__input"
																			placeholder={ tr.t("Cardnum") }
																			options={ {creditCard: true} }
																			onFocus={ this.onCreditCardFocus }
																			onChange={ this.onCreditCardChange }
																			onBlur={ (e)=>{this.validateCCInfo(e)} }
																		/>
																	</div>
																	{
																		this.state.errCCNumber &&
																		<div className="error">
																			{ tr.t("CCNumberIsWrong") }
																		</div>
																	}
																</div>
															</div>                          
														</div>
														<div className="row">
															<div className="col-12">
																<div className="sn_credit__container__rectangle">
																{
																	this.state.cardHolder &&
																	<label htmlFor="cardHolder" className="top-label">
																		{ tr.t("Fullnameinput") }
																	</label>
																}
																<input
																	id="cardHolder"
																	style={ {borderColor: this.state.errCardHolderName ? 'red': ''} } 
																	onBlur={ (e)=>{this.validateCCInfo(e)} } 
																	type="text"
																	name="name"
																	placeholder={ tr.t("Fullnameinput") }
																	onChange={ this.handleChangeHolderName }
																	className="sn_credit__container__wrap__input"
																	maxLength="50"
																/>
																{
																	this.state.errCardHolderName &&
																	<div className="error">
																			{ tr.t("CCHolderNameIsWrong") }
																	</div>
																}
																</div>
															</div>
														</div>
														<div className="row mb-5">
															<div className="col-12 col-sm-6">
																<div className="sn_credit__container__rectangle">
																		<MonthPicker
																			defaultValue={ tr.t("Month") }
																			numeric
																			short
																			endYearGiven
																			year={ this.state.year }
																			required= {false }
																			disabled={ false }
																			value={ this.state.month }
																			onChange={ (month) => {
																					if (month) {
																						this.setState({ mm: (Number(month) + 1).toString() });
																						//console.log((Number(month) + 1).toString());
																					}
																					else {
																						this.setState({ mm: "" });
																					}
																			}}
																			id={ 'month' }
																			name={ 'month' }
																			classes={ 'date-button month' }
																			optionClasses={ 'opbtnit' }
																		/>
																		<YearPicker
																			defaultValue={ tr.t("Year") }
																			start={ this.CCStartYear }
																			end={ this.CCEndYear }
																			required={ false }
																			disabled={ false }
																			value={ this.state.year }
																			onChange={ (year) => {
																					this.setState({ yyyy: year });
																					//console.log(year);
																			}}
																			id={'year'}
																			name={'year'}
																			classes={'date-button year'}
																			optionClasses={'opbtnit'}
																		/>
																	</div>
																</div>
																<div className="col-12 col-sm-6">
																	<div className="sn_credit__container__rectangle">
																	{
																		this.state.cvv &&
																		<label htmlFor="cvv" className="top-label">
																				{ tr.t("Cvv") }
																		</label>
																	}
																	<Cleave
																		id="cvv"
																		style={ { borderColor: this.state.errCvv ? 'red' : '' } }
																		className="sn_credit__container__wrap__input"
																		placeholder={ tr.t("Cvv") }
																		maxLength="3"
																		options={ {blocks: [3],uppercase: true} }
																		value={ this.state.code }
																		onChange={ this.onCVVchange }
																		onBlur={ (e) => { this.validateCCInfo(e) } }
																	/>
																	<div>
																	{
																		!this.state.cvv &&
																		<div className="info-quest">
																			<a onClick={() => this.onqmarkClicked()}>
																				<img src={ qmark } />
																			</a>
																		</div>
																	}
																		{
																			this.state.errCvv &&
																			<div>
																				<div className="error">
																					{ tr.t("CCCvvIsWrong") }
																				</div>
																			</div>
																		}
																		</div>
																	</div>
																</div>
															</div>
															<div className="row mb-3">
																<div className="col-12">
																	{
																		this.state.userTotals &&
																		this.state.userTotals.map((total, index) =>
																		{
																			if(index < this.state.userTotalsLastIndex)
																			{
																				return (
																					<div className="row" key={"price-info-row-" + index}>
																						<div className="col-12 d-flex justify-content-between">
																							<h6>{HtmlWrapper(total.desc)}</h6>
																							<h6>{HtmlWrapper(total.value)}</h6>
																						</div>
																					</div>
																				)
																			}
																			else
																			{
																				return (
																					this.state.userTotals &&
																					<div className="row" key={"price-info-row-" + index}>
																						<div className="col-12">
																							<div className="sn_credit__container__total">
																								<h5>{HtmlWrapper(this.state.userTotals[this.state.userTotalsLastIndex].desc)}</h5>
																								<h5>{HtmlWrapper(this.state.userTotals[this.state.userTotalsLastIndex].value)}</h5>
																							</div>
																						</div>
																					</div>
																				)
																			}
																		})
																	}
																</div>
															</div>
															<div className="row">
																<div className="col-12 d-flex justify-content-center">
																	<div className="sn_container__button">
																		<button disabled={ !(this.state.cardHolder != "" && this.state.cardNumber != "" && this.state.mm != "" && this.state.yyyy != "" && this.state.cvv != "") } className="sn_btn" onClick={ this.makeThePayment }>
																			{ tr.t("Pay")+" "+formatter.format(this.state.totalPrice) }
																		</button>
																</div>
															</div>
														</div>
														<div className="row d-lg-none mt-5">
															<div className="col-12">
																<ProgressBullets step={ this.state.step } />
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</BrowserView>
								<MobileView>
									<div className="container-fluid d-lg-none sn_mobile_top_row mt-5">
										<div className="row flex-nowrap">
											<div className="col-2 d-flex align-items-center">
											{/*	
												<button className="sn_btnbox" onClick={ this.onBack }><img className="sn_mobile_top_row_arrow" src={ miniArrow }/></button>
											*/}
											</div>
											<div className="col-8 d-flex align-items-center justify-content-center">
												<img className="sn_mobile_top_row_logo" src={ logo } />
											</div>
											<div className="col-2 d-flex align-items-center justify-content-end">
												<div className="sn_exit">
													<a onClick={() => { return this.props.history.push('/') }}>
														<img src={ clos } />
													</a>
												</div>
											</div>
										</div>
									</div>
									<div className="sn_topbar"><TopBar step={ this.state.step }/></div>
									<div className="sn_overlay d-lg-none"></div>
									<div className="sn_credit">
										<div className="container">
											<div className="row">
												<div className="col-12 col-lg-8 mx-auto">
													<div className="sn_register__container p-3 p-md-4 p-lg-5">
														<div className="row d-none d-lg-flex">
															<div className="col-12 d-flex justify-content-end">
																<div className="sn_exit">
																	<a onClick={() => { return this.props.history.push('/') }}>
																		<img src={ clos } />
																	</a>
																</div>
															</div>
														</div>
														<div className="row">
															<div className="col-12">
																<h3 className="text-center mb-4">{ tr.t("Insertpayinfo") }</h3> 
																<div className="sn_credit__container__rectangle">
																	{ 
																		this.state.cardNumber &&
																		<label htmlFor="ccNumber" className="top-label">
																			{ tr.t("Cardnum") }
																		</label>
																	}
																	<div className="sn_credit__container__wrap">
																		<div className="sn_credit__container__retangle__wrap__cards">
																			<img src= {this.state.ccType === 'Visa' ? visacard : this.state.ccType === 'Mastercard' ? mastercard : masterviza} />
																		</div>
																		<Cleave
																			id="ccNumber"
																			style={ {borderColor: this.state.errCCNumber ? 'red': ''} }
																			className="sn_credit__container__wrap__input"
																			placeholder={ tr.t("Cardnum") }
																			options={ {creditCard: true} }
																			onFocus={ this.onCreditCardFocus }
																			onChange={ this.onCreditCardChange }
																			onBlur={ (e)=>{this.validateCCInfo(e)} }
																		/>
																	</div>
																	{
																		this.state.errCCNumber &&
																		<div className="error">
																			{ tr.t("CCNumberIsWrong") }
																		</div>
																	}
																</div>
															</div>                          
														</div>
														<div className="row">
															<div className="col-12">
																<div className="sn_credit__container__rectangle">
																{
																	this.state.cardHolder &&
																	<label htmlFor="cardHolder" className="top-label">
																		{ tr.t("Fullnameinput") }
																	</label>
																}
																<input
																	id="cardHolder"
																	style={ {borderColor: this.state.errCardHolderName ? 'red': ''} } 
																	onBlur={ (e)=>{this.validateCCInfo(e)} } 
																	type="text"
																	name="name"
																	placeholder={ tr.t("Fullnameinput") }
																	onChange={ this.handleChangeHolderName }
																	className="sn_credit__container__wrap__input"
																	maxLength="50"
																/>
																{
																	this.state.errCardHolderName &&
																	<div className="error">
																			{ tr.t("CCHolderNameIsWrong") }
																	</div>
																}
																</div>
															</div>
														</div>
														<div className="row mb-5">
															<div className="col-12 col-sm-6">
																<div className="sn_credit__container__rectangle">
																		<MonthPicker
																			defaultValue={ tr.t("Month") }
																			numeric
																			short
																			endYearGiven
																			year={ this.state.year }
																			required= {false }
																			disabled={ false }
																			value={ this.state.month }
																			onChange={ (month) => {
																					if (month) {
																						this.setState({ mm: (Number(month) + 1).toString() });
																						//console.log((Number(month) + 1).toString());
																					}
																					else {
																						this.setState({ mm: "" });
																					}
																			}}
																			id={ 'month' }
																			name={ 'month' }
																			classes={ 'date-button month' }
																			optionClasses={ 'opbtnit' }
																		/>
																		<YearPicker
																			defaultValue={ tr.t("Year") }
																			start={ this.CCStartYear }
																			end={ this.CCEndYear }
																			required={ false }
																			disabled={ false }
																			value={ this.state.year }
																			onChange={ (year) => {
																					this.setState({ yyyy: year });
																					//console.log(year);
																			}}
																			id={'year'}
																			name={'year'}
																			classes={'date-button year'}
																			optionClasses={'opbtnit'}
																		/>
																	</div>
																</div>
																<div className="col-12 col-sm-6">
																	<div className="sn_credit__container__rectangle">
																	{
																		this.state.cvv &&
																		<label htmlFor="cvv" className="top-label">
																				{ tr.t("Cvv") }
																		</label>
																	}
																	<Cleave
																		id="cvv"
																		style={ { borderColor: this.state.errCvv ? 'red' : '' } }
																		className="sn_credit__container__wrap__input"
																		placeholder={ tr.t("Cvv") }
																		maxLength="3"
																		options={ {blocks: [3],uppercase: true} }
																		value={ this.state.code }
																		onChange={ this.onCVVchange }
																		onBlur={ (e) => { this.validateCCInfo(e) } }
																	/>
																	<div>
																	{
																		!this.state.cvv &&
																		<div className="info-quest">
																			<a onClick={() => this.onqmarkClicked()}>
																				<img src={ qmark } />
																			</a>
																		</div>
																	}
																		{
																			this.state.errCvv &&
																			<div>
																				<div className="error">
																					{ tr.t("CCCvvIsWrong") }
																				</div>
																			</div>
																		}
																		</div>
																	</div>
																</div>
															</div>
															<div className="row mb-3">
																<div className="col-12">
																	{
																		this.state.userTotals &&
																		this.state.userTotals.map((total, index) =>
																		{
																			if(index < this.state.userTotalsLastIndex)
																			{
																				return (
																					<div className="row" key={"price-info-row-" + index}>
																						<div className="col-12 d-flex justify-content-between">
																							<h6>{HtmlWrapper(total.desc)}</h6>
																							<h6>{HtmlWrapper(total.value)}</h6>
																						</div>
																					</div>
																				)
																			}
																			else
																			{
																				return (
																					this.state.userTotals &&
																					<div className="row" key={"price-info-row-" + index}>
																						<div className="col-12">
																							<div className="sn_credit__container__total">
																								<h5>{HtmlWrapper(this.state.userTotals[this.state.userTotalsLastIndex].desc)}</h5>
																								<h5>{HtmlWrapper(this.state.userTotals[this.state.userTotalsLastIndex].value)}</h5>
																							</div>
																						</div>
																					</div>
																				)
																			}
																		})
																	}
																</div>
															</div>
															<div className="row">
																<div className="col-12 d-flex justify-content-center">
																	<div className="sn_container__button">
																		<button disabled={ !(this.state.cardHolder != "" && this.state.cardNumber != "" && this.state.mm != "" && this.state.yyyy != "" && this.state.cvv != "") } className="sn_btn" onClick={ this.makeThePayment }>
																			{ tr.t("Pay")+" "+formatter.format(this.state.totalPrice) }
																		</button>
																</div>
															</div>
														</div>
														<div className="row d-lg-none mt-5">
															<div className="col-12">
																<ProgressBullets step={ this.state.step } />
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</MobileView>
								{
									this.state.alertWrong ?
									<div className="containerModal">
									{
										this.state.alerWrong ?
										<AlertPnl textbar1={tr.t("Oops")} secondbar={true} textbar2={this.state.bankErrMsg} doublebtnver={true} textbtn1={tr.t("Retry")} textbtn2={tr.t("Goto")} option1={"retry"} option2={"gotouser"} callback={this.alertResponse.bind(this)} />
										: null
									}
									</div> : null
								}
								{
									this.state.cvvGuidAlert ?
									<div className="containerModal">        
									{
										this.state.cvvGuidAlert ? <AlertPnl textbar1={tr.t("cvvDescription")} singlebtn={true} textbtn1={tr.t("Ok")} sizebtn={"small"} option1={"cvvOK"} callback={this.alertResponse.bind(this)} />
										: null
									}                            
									</div> : null
								}
							</div>
							<WaitLoad enable={this.state.isLoading || this.state.workFlowInProgress} />
							{ this.state.helpShow && <InfoModal info={this.state.helpMessage} show={true} onClose={() => this.setState({ helpShow: false })} />}
							{ this.state.gestpay && <GestPayHandler params={this.state.gestpayParams} callback={()=>this.setState({isLoading: false})}/>}
						</div>
					</Router>
				);
		}
}

export default Insericredito;


// WEBPACK FOOTER //
// ./src/screens/Insericredito/Insericredito.js